import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react"
import { baseUrl } from "constant"
import { VerifyPasswordUrl } from "./const"
import { RootState } from "store/store"
import { handlingErrorResponse } from "utils/HandlingErrorResponse"
import { getAuthToken } from "utils/getAuthToken"
import { IVerifyPasswordRequestTyype, IResponseType } from "./type"


export const AccountSettingsApi = createApi({
    reducerPath: 'AccountSettingsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['AccountSetting'],
    endpoints: (builder) => ({
        VerifyPassword: builder.query<IResponseType<boolean>, IVerifyPasswordRequestTyype>({
            query: (params) => VerifyPasswordUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'AccountSetting', id: 'VerifyPassword' }],
        }),

    }),
})